import { render, staticRenderFns } from "./DossierJaN1.vue?vue&type=template&id=910ca2dc&scoped=true"
import script from "./DossierJaN1.vue?vue&type=script&lang=js"
export * from "./DossierJaN1.vue?vue&type=script&lang=js"
import style0 from "./DossierJaN1.vue?vue&type=style&index=0&id=910ca2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910ca2dc",
  null
  
)

export default component.exports